import React, { useContext, useEffect, useState, useRef } from 'react';
import Icon9 from '../../assest/images/Icon9.png';
import x from '../../assest/images/x.png';
import Icon3 from "../../assest/images/Icon3.png";
import StatusCustomDropdown from '../common/StatusCustomDropdown';
import { Link, useParams } from 'react-router-dom';
import reset from '../../assest/images/reset.png';
import Image from '../common/image';
import CustomDropdown from '../common/CustomDropdown';
import axios from 'axios';
import config from "../../envconfig";
import { UserContext } from '../common/UserContext';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';
import { saveAs } from 'file-saver';
import { MdUpload, MdCancel, MdFileDownload } from "react-icons/md";

function UMList() {
    const [userData, setUserData] = useState([]);
    const [message, setMessage] = useState('');
    const [showPopup, setShowPopup] = useState(false);
    const [changePasswordPopup, setChangePasswordPopup] = useState(false);
    const [randomPassword, setRandomPassword] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [scpPopup, setScpPopup] = useState(false);
    const [scpNames, setSCPNames] = useState([]);
    const [plantLinePopup, setPlantLinePopup] = useState(false);
    const [plantLineData, setPlantLineData] = useState([]);
    const [lineDetailsPopup, setLineDetailsPopup] = useState(false);
    const [selectedPlantId, setSelectedPlantId] = useState(null);
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId, UM_UserType } = useContext(UserContext);
    const fileInputRef = useRef(null);
    const [firstFilter, setFirstFilter] = useState('');
    const [firstFilterSearch, setFirstFilterSearch] = useState('');
    const [secondFilter, setSecondFilter] = useState('');
    const [secondFilterSearch, setSecondFilterSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [statusFilter, setStatusFilter] = useState('');
    const [isSelectOpen, setIsSelectOpen] = useState(false);

    const [enumValues, setEnumValues] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setloading] = useState(false);




    const handleDownload = async (userId,userName) => {
        try {
            setloading(true);
            const response = await fetch(`${config.API_URL}/UM/getimage`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userId }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Image not found');
            }



            // Get the download name from the response header
            const downloadName = response.headers.get('X-Download-Name') || `user_${userId}.png`;

            // Get the image as a blob
            const blob = await response.blob();


            // Use FileSaver to download the file with the correct name
            saveAs(blob, downloadName);
            setloading(false)
            toast.success(`Image : ${downloadName} downloaded successfully for User : ${userName}.`);
        } catch (error) {
            console.error('Download failed:', error);
            toast.error(error.message || 'Failed to download image', {
                onClose: () => setloading(false)
            });
        }
    };



    useEffect(() => {
        const fetchEnumOptions = async () => {
            try {
                const response = await fetch(`${config.API_URL}/CITPM/enumtype`);
                if (!response.ok) throw new Error("Failed to fetch enum options");

                const data = await response.json();
                console.log("DATA", data);

                const values = data.map(item => item.EnumVal);
                setEnumValues(values);  // Store in state
                console.log("EnumVal State:", values);

            } catch (error) {
                console.error("Error fetching enum options:", error);
            }
        };

        fetchEnumOptions();
    }, []);



    const [firstFilterOptions, setFirstFilterOptions] = useState([

        ...(parseInt(UM_UserType) === 0 ? [

            { value: 'CM_CompanyName', label: 'Company Name', disabled: false },
        ] : []),
        { value: 'UM_UserCode', label: 'User Name', disabled: false },
        { value: 'UM_DisplayName', label: 'Display Name', disabled: false },
        { value: 'GRPM_GroupName', label: 'Group Name', disabled: false },
        // { value: 'UM_EmailAddress', label: 'Email', disabled: false },
        ...(parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1 ? [
            { value: 'UserType', label: 'User Type', disabled: false }
        ] : []),
    ]);

    const [secondFilterOptions, setSecondFilterOptions] = useState([

        ...(parseInt(UM_UserType) === 0 ? [

            { value: 'CM_CompanyName', label: 'Company Name', disabled: false },

        ] : []),
        { value: 'UM_UserCode', label: 'User Name', disabled: false },
        { value: 'UM_DisplayName', label: 'Display Name', disabled: false },
        { value: 'GRPM_GroupName', label: 'Group Name', disabled: false },
        // { value: 'UM_EmailAddress', label: 'Email', disabled: false },
        ...(parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1 ? [
            { value: 'UserType', label: 'User Type', disabled: false }
        ] : []),
    ]);

    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);
        sessionStorage.setItem('selectedScpId', selectedScpId);
        sessionStorage.setItem("UM_UserType", UM_UserType);
    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId, UM_UserType]);

    useEffect(() => {
        setCurrentPage(1);
    }, [firstFilterSearch, secondFilterSearch, statusFilter]);

    const logAction = async (action, isError = false) => {
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "User Master", action, userCode: UM_UserCode, isError }),
            });

            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };

    useEffect(() => {

        getUserdata();
    }, [message, UM_UserCode, UM_UserId]);

    const getUserdata = async () => {

        try {
            const reqData = await fetch(`${config.API_URL}/UM/UMList`, {
                method: 'POST', // or PUT, depending on your API
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    UM_UserCode,
                    UM_UserId,
                    UM_UserType,
                    UM_CompanyID
                }),
            });
            const resData = await reqData.json();

            if (resData.success) {
                setUserData(resData.data || []);
            } else {
                console.error('Error fetching user data:', resData.error);
                setMessage('Error fetching user data. Please try again.');

            }
        } catch (error) {

            setMessage('Please check Data');
            logAction('getUserdata():Failed to fetch data', true);
        }

    };

    const fetchSCPNames = async (id) => {

        try {
            const url = `${config.API_URL}/UM/userscpdata/${id}`;
            const response = await fetch(url);

            if (response.ok) {
                const data = await response.json();
                if (data.success) {
                    setSCPNames(data.data);
                    setMessage('');
                } else {
                    setMessage('Error fetching SCP names');
                    logAction('fetchSCPNames():Error fetching SCP names', true);
                }
            } else {
                console.error('Error fetching SCP names. Status:', response.status);

            }
        } catch (error) {
            console.error('Failed to fetch SCP names:', error);
            setMessage('Please check the data');

        }

    };

    const fetchPlantLineData = async (userId) => {
        logAction('fetchPlantLineData():Started');
        try {
            const response = await fetch(`${config.API_URL}/UM/resourcelistdata`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ userId }),
            });

            const data = await response.json();
            if (data.success) {
                // Map API response to include plantId and lineId
                const mappedData = data.data.map(item => ({
                    plantId: item.plantid, // Map PM_PlantID to plantId
                    lineId: item.lineid,   // Map LM_LineID to lineId
                    plantName: item.plantName,
                    lineName: item.lineName,
                    plantCode: item.plantCode,
                    lineCode: item.lineCode
                }));
                setPlantLineData(mappedData || []);
                setMessage('');
            } else {
                setMessage(data.error || 'Error fetching plant line data');
                logAction(`fetchPlantLineData():${data.error || 'Error fetching plant line data'}`, true);
            }
        } catch (error) {
            console.error('Failed to fetch plant line data:', error);
            setMessage('Please check the data');
            logAction('fetchPlantLineData():Please check the data', true);
        }
        logAction('fetchPlantLineData():Ended');
    };

    const handleFirstFilterChange = (event) => {

        const value = event.target.value;
        setFirstFilter(value);
        setFirstFilterSearch('');

        const updatedSecondOptions = secondFilterOptions.map(option => ({
            ...option,
            disabled: option.value === value
        }));
        setSecondFilterOptions(updatedSecondOptions);

    };

    const handleSecondFilterChange = (event) => {

        const value = event.target.value;
        setSecondFilter(value);
        setSecondFilterSearch('');

        const updatedFirstOptions = firstFilterOptions.map(option => ({
            ...option,
            disabled: option.value === value
        }));
        setFirstFilterOptions(updatedFirstOptions);

    };

    const handleStatusFilterChange = (event) => {

        const value = event.target.value;
        setStatusFilter(value);

    };

    const getStatusLabel = (status) => {
        switch (status) {
            case 1:
                return 'Active';
            case 2:
                return 'Inactive';
            case 3:
                return 'Suspend';
            default:
                return '';
        }
    };

    const filteredListData = userData.filter(item => {
        const firstFilterValue = item[firstFilter];
        const secondFilterValue = item[secondFilter];
        const statusValue = getStatusLabel(item.UM_Status);
        const containsActive = /act(ive)?/i.test(firstFilterSearch);
        const containsInactive = /inact(ive)?/i.test(firstFilterSearch);

        const matchesFirstFilter =
            (!firstFilter || !firstFilterSearch) ||
            (firstFilter === 'UM_Status' &&
                (
                    (containsActive && firstFilterValue === 1) ||
                    (containsInactive && firstFilterValue === 2)
                )
            ) ||
            (firstFilter !== 'UM_Status' && String(firstFilterValue).toLowerCase().includes(firstFilterSearch.toLowerCase()));
        const containsActive2 = /act(ive)?/i.test(secondFilterSearch);
        const containsInactive2 = /inact(ive)?/i.test(secondFilterSearch);

        const matchesSecondFilter =
            (!secondFilter || !secondFilterSearch) ||
            (secondFilter === 'UM_Status' &&
                (
                    (containsActive2 && secondFilterValue === 1) ||
                    (containsInactive2 && secondFilterValue === 2)
                )
            ) ||
            (secondFilter !== 'UM_Status' && String(secondFilterValue).toLowerCase().includes(secondFilterSearch.toLowerCase()));

        const matchesStatusFilter = !statusFilter || statusValue === statusFilter;

        return matchesFirstFilter && matchesSecondFilter && matchesStatusFilter;
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredListData.slice(indexOfFirstItem, indexOfLastItem);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleResetPassword = (user) => {
        setSelectedUser(user);
        setShowPopup(true);
    };

    const handleScpPopup = (id) => {
        setSelectedUser(id);
        setScpPopup(true);
        fetchSCPNames(id);
    };

    const handlePlantLinePopup = (userId) => {
        setSelectedUser(userId);
        setPlantLinePopup(true);
        fetchPlantLineData(userId);
    };

    const handleLineDetailsPopup = (plantId, plantName) => {
        setSelectedPlantId({ id: plantId, name: plantName });
        setLineDetailsPopup(true);
    };

    const handleChangePassword = async () => {
        logAction('handleChangePassword():Started');
        try {
            const userId = selectedUser.UM_UserId;
            const response = await fetch(`${config.API_URL}/UM/resetpassword/${userId}`, {
                method: 'PATCH',
            });

            if (response.ok) {
                const result = await response.json();
                logAction(`handleChangePassword(): User : ${selectedUser.UM_UserCode}'s password reset successfully`);

                if (result.message === 'Password reset successfully') {
                    const details = {

                        AUTR_Message: `Password reset successfully for User : ${selectedUser.UM_UserCode}`,
                        AUTR_SCPID: result.UM_DefaultSCPId,
                        AUTR_CompanyGrpId: result.UM_CompanyGrpID,
                        AUTR_CompanyID: result.UM_CompanyID

                    };
                    await audittrailpost(details);

                    setRandomPassword(result.newPassword);
                    //    toast.success(`Password reset successfully for User : ${selectedUser.UM_UserCode}`)
                    setChangePasswordPopup(true);
                    setShowPopup(false);
                } else {
                    console.error('Error updating password:', result.message);
                    logAction('handleChangePassword():Error updating password', true);
                }
            } else {
                console.error('Failed to update password. Server returned:', response.status);
                logAction('handleChangePassword():Failed to update password. Server returned', true);
            }
        } catch (error) {
            console.error('Network error or failed to update password:', error.message);
            logAction('handleChangePassword():Network error or failed to update password', true);
        }
        logAction('handleChangePassword():Ended');
    };

    const audittrailpost = async (details) => {
        const getCurrentTimestamp = () => {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };

        const currentTimestamp = getCurrentTimestamp();
        const AUTR_OldValue = details?.AUTR_OldValue ?? null;
        const AUTR_NewValue = details?.AUTR_NewValue ?? null;
        const AUTR_Message = details.AUTR_Message;


        const data = {
            AUTR_ScreenName: "User Master",
            AUTR_OldValue: AUTR_OldValue,
            AUTR_NewValue: AUTR_NewValue,
            AUTR_Message: AUTR_Message,
            AUTR_UserID: UM_UserId,
            AUTR_UserName: UM_UserCode,
            AUTR_TimeStamp: currentTimestamp,
            AUTR_AuditType: 10,
            AUTR_SCPID: details.AUTR_SCPID,
            AUTR_CompanyGrpId: details.AUTR_CompanyGrpId,
            AUTR_CompanyID: details.AUTR_CompanyID,
            AUTR_CreatedBy: UM_UserId,
            AUTR_CreatedDateTime: currentTimestamp
        };

        try {
            const response = await axios.post(`${config.API_URL}/api/audittrail`, data);
            return response.data;
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);
    };

    // const handleChange = async (e, UM_UserId, userName) => {
    //     const input = e.target;
    //     const rawFile = input.files?.[0];
    //     if (!rawFile) return;

    //     // 🔐 DETACH FILE FROM INPUT (CRITICAL)
    //     const file = new File([rawFile], rawFile.name, {
    //         type: rawFile.type,
    //         lastModified: rawFile.lastModified,
    //     });

    //     const validTypes = ["image/jpeg", "image/jpg", "image/png"];
    //     if (!validTypes.includes(file.type)) {
    //         toast.error("Only JPG, JPEG and PNG images are allowed.");
    //         input.value = "";
    //         return;
    //     }

    //     const maxSize = 200 * 1024;
    //     if (file.size > maxSize) {
    //         toast.error("Image size must be less than 200 KB.");
    //         input.value = "";
    //         return;
    //     }


    //     try {
    //         const formData = new FormData();
    //         formData.append("userId", UM_UserId);
    //         formData.append("image", file);

    //         console.log("UM_UserId in upload:", formData);
    //         const response = await fetch(`${config.API_URL}/UM/uploadimage`, {
    //             method: "POST",
    //             body: formData,
    //             keepalive: true, // ✅ VERY IMPORTANT
    //         });

    //         const text = await response.text();
    //         const data = JSON.parse(text);

    //         if (!response.ok) throw new Error(data.message);

    //         toast.success(`Image uploaded successfully for User : ${userName}.`);

    //         // delay rerender until upload fully finishes
    //         setTimeout(() => {
    //             getUserdata();
    //         }, 0);

    //     } catch (error) {
    //         console.error("Image upload failed:", error);
    //         toast.error(error.message || "Upload failed");
    //     } finally {
    //         input.value = "";
    //     }
    // };

    const handleChange = async (e, UM_UserId, userName) => {
        setloading(true);
        const input = e.target;
        const file = input.files?.[0];
        if (!file) return;

        const validTypes = ["image/jpeg", "image/jpg", "image/png"];
        if (!validTypes.includes(file.type)) {
            toast.error("Only JPG, JPEG and PNG images are allowed.", {
                onClose: () => setloading(false)
            });
            input.value = "";
            return;
        }

        const maxSize = 200 * 1024;
        if (file.size > maxSize) {
            toast.error("Image size must be less than 200 KB.", {
                onClose: () => setloading(false)
            });
            input.value = "";
            return;
        }

        try {
            const formData = new FormData();
            formData.append("userId", UM_UserId.toString());
            formData.append("image", file);

            const response = await fetch(`${config.API_URL}/UM/uploadimage`, {
                method: "POST",
                body: formData,
            });

            const data = await response.json();

            if (!response.ok) throw new Error(data.message);
            console.log(file)

            toast.success(`Image : ${file.name} uploaded successfully for User : ${userName}.`, {
                onClose: () => setloading(false) // ✅ STOP ON TOAST CLOSE
            });

            getUserdata();

        } catch (error) {
            toast.error(error.message || "Upload failed", {
                onClose: () => setloading(false) // ✅ STOP ON TOAST CLOSE
            });
        } finally {
            input.value = "";
        }
    };


    const handleDelete = async (userId, userName) => {
        try {
            setloading(true);
            const response = await fetch(`${config.API_URL}/UM/deleteimage/${userId}`, {
                method: "DELETE",
            });

            const data = await response.json();

            if (!response.ok) {
                console.error("Error deleting image:", data);
                toast.error(data.message || "Failed to remove image.", {
                    onClose: () => setloading(false)
                });
                return;
            }

            // Use the returned data from DELETE API
            const { UM_CompanyGrpID, UM_CompanyID, UM_DefaultSCPId, UM_ImageName } = data.data;

            const details = {
                AUTR_Message: `Image : ${UM_ImageName} removed successfully for User : ${userName}`,
                AUTR_SCPID: UM_DefaultSCPId,
                AUTR_CompanyGrpId: UM_CompanyGrpID,
                AUTR_CompanyID: UM_CompanyID
            };


            await audittrailpost(details);


            toast.success(`Image : ${UM_ImageName} removed successfully for User : ${userName}.`, {
                onClose: () => setloading(false)
            });

            setIsModalOpen(false); // close modal
            getUserdata();
        } catch (error) {
            console.error("Error removing image:", error);
            toast.error("Failed to remove image.", {
                onClose: () => setloading(false)
            });
        }
    };


    return (
        <React.Fragment>
            {loading && (
                <div style={{
                    position: 'fixed', // Sit on top of the page content
                    left: 0,
                    top: 0,
                    width: '100%', // Full width
                    height: '100%', // Full height
                    zIndex: 1000 // Sit on top of the other elements
                }} />
            )}
            <ToastContainer style={{
                marginTop: '73px',
                fontSize: '14px',
                width: '40%',
            }} />
            <div className="main_container">
                <h3 className="formHeading">User Master</h3>
                <p>{message}</p>
                <div className="filter-container">
                    <div className='select-container_list'>
                        <CustomDropdown
                            options={firstFilterOptions}
                            value={firstFilter}
                            onChange={handleFirstFilterChange}
                            name="firstFilter"
                            placeholder="--Select--"
                            idKey="value"
                            displayKey="label"
                            onMenuOpen={() => handleSelectOpen('firstFilter')}
                            onMenuClose={handleSelectClose}
                        />
                    </div>
                    <input type="text"
                        className='search-input'
                        value={firstFilterSearch}
                        onChange={(e) => setFirstFilterSearch(e.target.value)}
                        placeholder={`Search`} />

                    <div className='select-container_list'>
                        <CustomDropdown
                            options={secondFilterOptions}
                            value={secondFilter}
                            onChange={handleSecondFilterChange}
                            name="secondFilter"
                            placeholder="--Select--"
                            idKey="value"
                            displayKey="label"
                            onMenuOpen={() => handleSelectOpen('secondFilter')}
                            onMenuClose={handleSelectClose}
                        />
                    </div>
                    <input type="text"
                        className='search-input'
                        value={secondFilterSearch}
                        onChange={(e) => setSecondFilterSearch(e.target.value)}
                        placeholder='Search' />

                    <div className='select-container_list'>
                        <StatusCustomDropdown
                            options={[
                                { value: '', label: '--Select Status--' },
                                { value: 'Active', label: 'Active' },
                                { value: 'Inactive', label: 'Inactive' },
                            ]}
                            value={statusFilter}
                            onChange={handleStatusFilterChange}
                            name="statusFilter"

                            idKey="value"
                            displayKey="label"
                            onMenuOpen={() => handleSelectOpen('statusFilter')}
                            onMenuClose={handleSelectClose}
                        />
                    </div>
                </div>

                <div className="ptable-wrapper">
                    <table className="ptableClass">
                        <thead>
                            <tr>
                                <th style={{ width: "70px" }}>Sr. No.</th>
                                {(parseInt(UM_UserType) === 0) && (
                                    <><th>Company Name</th></>
                                )}
                                <th>User Name</th>
                                <th>Display Name</th>
                                <th>Group Name</th>
                                {/* <th>Email</th> */}
                                {(parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) && (
                                    <th style={{ width: '100px' }}>User Type</th>
                                )}


                                {/* 👇 Hide SCP column if usertype = 2 */}
                                {parseInt(UM_UserType) !== 2 & enumValues.includes(3) && (
                                    <th>SCP Name List</th>
                                )}

                                {/* 👇 Hide Resource column if usertype = 3 */}
                                {parseInt(UM_UserType) !== 3 && enumValues.includes(2) && (
                                    <th>Resource Details</th>
                                )}
                                <th style={{ width: '65px' }}>Status</th>
                                <th>Reset Password</th>
                                <th>Image</th>
                                <th>Action</th>

                            </tr>
                        </thead>
                        {filteredListData.length === 0 ? (
                            <tbody>
                                <tr>
                                    <td colSpan="11">No Records Found</td>
                                </tr>
                            </tbody>
                        ) : (
                            <tbody>
                                {console.log(currentItems)}
                                {currentItems.map((user, index) => (
                                    <tr key={index}>
                                        <td style={{ width: "70px" }}>
                                            {index + 1 + (currentPage - 1) * itemsPerPage}
                                        </td>
                                        {(parseInt(UM_UserType) === 0) && (
                                            <><td>{user.CM_CompanyName}</td></>
                                        )}
                                        <td>{user.UM_UserCode}</td>
                                        <td>{user.UM_DisplayName}</td>
                                        <td>{user.GRPM_GroupName}</td>

                                        {(parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) && (
                                            <td style={{ width: '100px' }}>{user.UserType}</td>
                                        )}

                                        {parseInt(UM_UserType) !== 2 & enumValues.includes(3) && (
                                            <td>
                                                {![1, 2].includes(parseInt(user.UserTypeID)) ? (
                                                    <Link onClick={() => handleScpPopup(user.UM_UserId)} title="Details">
                                                        <Image src={Icon9} alt="pool" className="poolimage" />
                                                        {user.UM_SCPCode}
                                                    </Link>
                                                ) : "N/A"}
                                            </td>
                                        )}
                                        {parseInt(UM_UserType) !== 3 && enumValues.includes(2) && (
                                            <td>
                                                {![1, 3].includes(parseInt(user.UserTypeID)) ? (
                                                    <Link onClick={() => handlePlantLinePopup(user.UM_UserId)} title="Plant Line Details">
                                                        <Image src={Icon9} alt="pool" className="poolimage" />
                                                        {user.UM_SCPCode}
                                                    </Link>
                                                ) : "N/A"}
                                            </td>
                                        )}

                                        <td style={{ width: '65px' }}>
                                            {user.UM_Status === 1 && 'Active'}
                                            {user.UM_Status === 2 && 'Inactive'}
                                        </td>
                                        <td>
                                            {user.UM_Status !== 2 && (
                                                <Link onClick={() => handleResetPassword(user)} title='Reset'>
                                                    <Image src={reset} alt="resetpassword" className="resetimage text-center" />
                                                </Link>
                                            ) || "-"}
                                        </td>

                                        <td style={{ verticalAlign: "middle" }}>
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                                                {/* Upload */}
                                                <div>
                                                    <input
                                                        type="file"
                                                        style={{ display: "none" }}
                                                        ref={fileInputRef}
                                                        accept="image/*"
                                                        onChange={(e) => handleChange(e, user.UM_UserId, user.UM_UserCode)}
                                                        id={`upload-input-${user.UM_UserId}`}
                                                    />
                                                    <MdUpload
                                                        size={20}
                                                        title="Upload"
                                                        onClick={() =>
                                                            document.getElementById(`upload-input-${user.UM_UserId}`).click()
                                                        }
                                                        style={{ cursor: "pointer" }}
                                                    />
                                                </div>

                                                {/* Download */}
                                                <div>
                                                    {user.UM_ImageName ? (
                                                        <Link onClick={() => handleDownload(user.UM_UserId,user.UM_UserCode)}>
                                                            <MdFileDownload
                                                                size={20}
                                                                title="Download"
                                                                style={{ cursor: "pointer",color:"#465a64" }}
                                                            />
                                                        </Link>
                                                    ) : (
                                                        <MdFileDownload
                                                            size={20}
                                                            title="Download"
                                                            style={{ opacity: 0.4 }}
                                                        />
                                                    )}
                                                </div>

                                                {/* Delete */}
                                                <div>
                                                    {user.UM_ImageName ? (
                                                        <Link
                                                            onClick={() => {
                                                                setSelectedUser({ id: user.UM_UserId, code: user.UM_UserCode });
                                                                setIsModalOpen(true);
                                                            }}
                                                        >
                                                            <MdCancel
                                                                size={20}
                                                                title="Remove"
                                                                style={{ cursor: "pointer",color:"#465a64" }}
                                                            />
                                                        </Link>
                                                    ) : (
                                                        <MdCancel
                                                            size={20}
                                                            title="Remove"
                                                            style={{ opacity: 0.4 }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </td>


                                        <td style={{ paddingLeft: '15px' }}>
                                            {parseInt(user.CITPM_CreatedBy) === 0 && parseInt(UM_UserType) !== 0 ?
                                                "-"
                                                :
                                                <>
                                                    <Link
                                                        to={`/dashboard/usermaster`}
                                                        state={{ user, isEditMode: true }}
                                                        title="Edit"
                                                    >
                                                        <Image src={Icon3} alt="pencil" className="editicon" width={25} />
                                                    </Link>
                                                </>
                                            }
                                        </td>



                                    </tr>
                                ))}
                            </tbody>
                        )}
                    </table>
                </div>

                {isModalOpen && selectedUser && (
                    <div className="popup_overlay">
                        <div className="resetpopup">
                            <h1>:: User Confirmation ::</h1>
                            <h4>Are you sure you want to remove the image for User : {selectedUser.code} ?</h4>

                            <div className="popup_btn_container">
                                <button className="yes_btn" onClick={async () => {
                                    await handleDelete(selectedUser.id, selectedUser.code);
                                    document.getElementById(`upload-input-${selectedUser.id}`).value = ""; // reset input
                                    setIsModalOpen(false);
                                }}>YES</button>
                                <button className="no_btn" onClick={() => setIsModalOpen(false)}>NO</button>
                            </div>
                        </div>
                    </div>
                )}


                <ul className="pagination">
                    <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(1)}>First</button>
                    </li>
                    <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
                    </li>
                    {Array.from({ length: Math.ceil(filteredListData.length / itemsPerPage) }, (_, index) => (
                        <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
                            <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
                        </li>
                    ))}
                    <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
                    </li>
                    <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(Math.ceil(filteredListData.length / itemsPerPage))}>Last</button>
                    </li>
                </ul>

                {showPopup && (
                    <div className="popup_overlay">
                        <div className="resetpopup">
                            <h1>:: User Confirmation ::</h1>
                            <h4>Are you sure you want to reset the password for User : {selectedUser?.UM_UserCode} ?</h4>
                            <div className="popup_btn_container">
                                <button className="yes_btn" onClick={handleChangePassword}>YES</button>
                                <button className="no_btn" onClick={() => setShowPopup(false)}>NO</button>
                            </div>
                        </div>
                    </div>
                )}

                <Modal
                    show={changePasswordPopup}
                    onHide={() => setChangePasswordPopup(false)}
                    centered
                    backdrop="static"
                    keyboard={false}
                    animation={false} style={{ backdropFilter: 'blur(3px)', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}
                >
                    <Modal.Body>
                        <div className="modalContainer">
                            <h3
                                style={{
                                    textAlign: "center",
                                    color: "#465a64",
                                    fontSize: "20px",
                                    fontWeight: "bold",
                                    margin: "10px",
                                    marginTop: "20px",
                                    marginBottom: "10px",
                                }}
                            >
                                :: User Confirmation ::
                            </h3>
                            <p
                                style={{
                                    textAlign: "center",
                                    marginTop: "10px",
                                    color: "#465a64",
                                    fontSize: "16px",
                                    fontWeight: "500",
                                }}
                            >
                                Password reset successfully
                            </p>
                            <p
                                style={{
                                    textAlign: "center",
                                    color: "#465a64",
                                    fontSize: "16px",
                                    fontWeight: "500",
                                }}
                            >
                                Please note down below details to login.
                            </p>
                            <div
                                style={{
                                    marginLeft: "145px",
                                    color: "#465a64",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                }}
                            >
                                <div style={{ marginBottom: '6px' }}>
                                    <div style={{ display: "flex" }}>
                                        <span style={{ width: "100px", flexShrink: 0 }}>User Name :</span>
                                        <span
                                            style={{
                                                wordBreak: "break-word",
                                                whiteSpace: "pre-wrap",
                                                userSelect: "text",
                                            }}
                                        >
                                            {selectedUser?.UM_UserCode}
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    <div style={{ display: "flex" }}>
                                        <span style={{ width: "100px", flexShrink: 0 }}>Password&ensp;&ensp;:</span>
                                        <span
                                            style={{
                                                wordBreak: "break-word",
                                                whiteSpace: "pre-wrap",
                                                userSelect: "text",
                                            }}
                                        >
                                            {randomPassword}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginTop: "5px",
                                }}
                            >
                                <button className="ok_btn" onClick={() => setChangePasswordPopup(false)}>
                                    OK
                                </button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal
                    show={plantLinePopup}
                    onHide={() => setPlantLinePopup(false)}
                    size="lg"
                    backdrop="static"
                    centered
                    keyboard={false}
                    animation={false} style={{ backdropFilter: 'blur(3px)', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}
                >

                    <Modal.Header closeButton>
                        <Modal.Title>Plant Line Details</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <table className="tableClass">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Plant Name</th>
                                    <th>Plant Code</th>
                                    <th>Line Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                {plantLineData.length === 0 ? (
                                    <tr>
                                        <td colSpan="4">No Records Found</td>
                                    </tr>
                                ) : (
                                    // Group by plantId to avoid duplicate plants
                                    Array.from(
                                        new Map(
                                            plantLineData.map(item => [
                                                item.plantId,
                                                {
                                                    plantId: item.plantId,
                                                    plantName: item.plantName,
                                                    plantCode: item.plantCode
                                                }
                                            ])
                                        ).values()
                                    ).map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>

                                            <td>{item.plantName}</td>
                                            <td>{item.plantCode}</td>
                                            <td>


                                                <Link onClick={() => handleLineDetailsPopup(item.plantId, item.plantName)} title='Reset'>
                                                    <Image src={Icon9} alt="pool" className="poolimage" />
                                                </Link>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>


                    </Modal.Body>
                </Modal>

                <Modal
                    show={lineDetailsPopup}
                    onHide={() => setLineDetailsPopup(false)}
                    size="lg"
                    backdrop="static"
                    centered
                    keyboard={false}
                    animation={false} style={{ backdropFilter: 'blur(3px)', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}
                >

                    <Modal.Header closeButton>
                        <Modal.Title>Line Details for Plant : {selectedPlantId?.name}</Modal.Title>
                    </Modal.Header>


                    <Modal.Body>


                        <table className="tableClass">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Line Name</th>
                                    <th>Line Code</th>
                                </tr>
                            </thead>
                            <tbody>
                                {plantLineData.filter(item => item.plantId === selectedPlantId?.id).length === 0 ? (
                                    <tr>
                                        <td colSpan="3">No Records Found</td>
                                    </tr>
                                ) : (
                                    plantLineData
                                        .filter(item => item.plantId === selectedPlantId?.id)
                                        .map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.lineName}</td>
                                                <td>{item.lineCode}</td>
                                            </tr>
                                        ))
                                )}
                            </tbody>
                        </table>

                    </Modal.Body>
                </Modal>

                <Modal show={scpPopup} onHide={() => setScpPopup(false)} size="lg"
                    backdrop="static"
                    centered
                    keyboard={false}
                    animation={false} style={{ backdropFilter: 'blur(3px)', backgroundColor: 'rgba(0, 0, 0, 0.3)' }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>SCP Name List</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <table className="tableClass">
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>SCP Name</th>
                                </tr>
                            </thead>
                            <tbody>
                                {scpNames.map((scpName, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{scpName}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Modal.Body>


                </Modal>

            </div>
            <Link to={`/dashboard/usermaster`} className="back_btn" type="button">
                BACK
            </Link>
        </React.Fragment>
    );
}

export default UMList;
